import AddIcon from '@mui/icons-material/Add';
import { Box, Button, Container, Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';
import { DataGridPremium, GridToolbar, LicenseInfo } from '@mui/x-data-grid-premium';
import { deDE } from '@mui/x-data-grid/locales';
import { get } from 'lodash';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuthentication } from '../../../context/AuthContext';
import GetRecords from '../../../lib/api/GetRecords';
import { APIS } from '../../../lib/constants/apis';
import { MUIX_LICENSE } from '../../../lib/constants/constant';
import { PAGES_URLS } from '../../../lib/constants/routes';
import { DisplayDate } from '../../../utils/formats';
import { enumT, getFieldNamefromDataPath, removeDataKeys, removeNullDeep } from '../../../utils/helper';

// import Schemas
import Schema from '../../../lib/paths/antrag_FULL_Paths.json';
import DeleteIcon from '@mui/icons-material/Delete';
import DeleteRecord from '../../../lib/api/DeleteRecord';
import MuiSnackbar from '../../../components/ui-component/mui-snackbar/MuiSnackbar';
let P = Schema.attributes;

LicenseInfo.setLicenseKey(MUIX_LICENSE);

function MeineAntraege() {
	const navigate = useNavigate();
	const location = useLocation();
	const { authenticatedData } = useAuthentication();
	const [wsActive, setWsActive] = useState(true);
	const [wsError, setWsError] = useState(false);
	const [data, setData] = useState<any>([]);
	const [openDialog, setOpenDialog] = useState<boolean>(false);
	const [selectedAntrag, setSelectedAntrag] = useState<number | any>(null);
	const [openSuccessSnackbar, setOpenSuccessSnackbar] = useState<boolean>(false);

	const handleDeleteClick = async (id: number) => {
		setOpenDialog(true);
		setSelectedAntrag(id);
	};

	const handleDeleteAntrag = async () => {
		await DeleteRecord(APIS.Antrag, selectedAntrag).then(() => {
			setData((prevData: any) => prevData.filter((ele: any) => ele.id !== selectedAntrag));
			setOpenSuccessSnackbar(true);
		});
	};

	const columns = [
		// {
		// 	field: 'id',
		// 	headerName: 'ID',
		// 	width: 50,
		// },
		{
			field: getFieldNamefromDataPath(P.Zusammenfassung_Ueberblick_Titel.path),
			headerName: 'Antragstitel',
			flex: 1,
			maxWidth: 330,
		},
		{
			field: getFieldNamefromDataPath(P.Status_Status.path),
			headerName: 'Status',
			flex: 1,
		},
		{
			field: getFieldNamefromDataPath(P.Zusammenfassung_Ueberblick_Laufzeit_Von.path),
			headerName: 'Laufzeit von',
			flex: 1,
			maxWidth: 130,
		},
		{
			field: getFieldNamefromDataPath(P.Zusammenfassung_Ueberblick_Laufzeit_Bis.path),
			headerName: 'Laufzeit bis',
			flex: 1,
			maxWidth: 130,
		},
		{
			field: getFieldNamefromDataPath(P.itaros_created.path),
			headerName: 'Erstellt am',
			flex: 1,
			maxWidth: 130,
		},
		{
			field: '',
			headerName: '',
			flex: 1,
			maxWidth: 40,
			disableColumnMenu: true,
			renderCell: (params: any) => {
				return params.row.Status_Status === "In Bearbeitung" ?
					<DeleteIcon
						onClick={(e) => {
							e.stopPropagation();
							handleDeleteClick(params.row.id);
						}}
						fontSize="small"
						sx={{
							cursor: 'pointer',
							'&:hover': {
								color: 'error.dark',
							},
						}}
					/>
					:
					'';
			},
		},
	];

	useEffect(() => {
		const fetch = async () => {
			try {
				let filter = {
					[getFieldNamefromDataPath(P.MKS.path)]: { id: get(authenticatedData, 'organisationId', -1) },
				};
				let res = await GetRecords(APIS.Antrag, ['MKS'], filter, [{ updatedAt: 'desc' }]);
				const transformedData = removeNullDeep(removeDataKeys(get(res, 'data', [])))
					.filter((ele: Record<string, any>) => {
						const title = get(ele, P.Zusammenfassung_Ueberblick_Titel.path);
						return title !== null && title !== undefined && title !== '';
					})
					.map((ele: Record<string, any>) => {
						return {
							id: get(ele, 'id'),
							[getFieldNamefromDataPath(P.Zusammenfassung_Ueberblick_Laufzeit_Von.path)]:
								get(ele, P.Zusammenfassung_Ueberblick_Laufzeit_Von.path) ?
									DisplayDate(get(ele, P.Zusammenfassung_Ueberblick_Laufzeit_Von.path))
									: '-',
							[getFieldNamefromDataPath(P.Zusammenfassung_Ueberblick_Laufzeit_Bis.path)]:
								get(ele, P.Zusammenfassung_Ueberblick_Laufzeit_Bis.path) ?
									DisplayDate(get(ele, P.Zusammenfassung_Ueberblick_Laufzeit_Bis.path))
									: '-',
							[getFieldNamefromDataPath(P.Status_Status.path)]: enumT(get(ele, P.Status_Status.path)),
							[getFieldNamefromDataPath(P.Zusammenfassung_Ueberblick_Titel.path)]: enumT(get(ele, P.Zusammenfassung_Ueberblick_Titel.path)),
							[getFieldNamefromDataPath(P.itaros_created.path)]: enumT(get(ele, 'attributes.createdAt')) ? DisplayDate(get(ele, 'attributes.createdAt')) : '-',

						};
					});

				setData(transformedData);
				setWsActive(true);
			} catch (err: any) {
				console.error('ERROR: Fetching Applications ', err);
				setWsError(true);
			} finally {
				setWsActive(false);
			}
		};

		fetch();
	}, [authenticatedData]);

	if (wsError) {
		return <Typography>Etwas is scheif gelaufen</Typography>;
	}

	return (
		<Container>
			<Dialog open={openDialog} onClose={() => setOpenDialog(false)} sx={{}}>
				<DialogTitle>{'Antrag löschen'}</DialogTitle>
				<DialogContent>
					Möchten Sie den Antrag unwiderruflich löschen?
				</DialogContent>
				<DialogActions>
					<Button variant="outlined" onClick={() => setOpenDialog(false)}>
						Abbrechen
					</Button>
					<Button
						onClick={() => {
							setOpenDialog(false);
							handleDeleteAntrag();
						}}
					>
						Löschen
					</Button>
				</DialogActions>
			</Dialog>
			<MuiSnackbar showSnackbar={openSuccessSnackbar} closeSnackbar={() => setOpenSuccessSnackbar(false)} alertMessage='Der Antrag wurde gelöscht.' />

			<Stack direction={{ xs: 'column', md: 'row' }} spacing={2} justifyContent={'space-between'}>
				<Typography variant='h3'> Meine Anträge</Typography>
				<Button endIcon={<AddIcon />}
					onClick={() => navigate(PAGES_URLS.CreateAntrag)}>
					Antrag erstellen
				</Button>
			</Stack>

			<Box sx={{ mt: '2rem' }}>
				<DataGridPremium
					loading={wsActive}
					autoHeight
					pagination
					pageSizeOptions={[5, 10, 25, 50, 100]}
					rows={data}
					columns={columns}
					columnVisibilityModel={{ Skizze: false }}
					onRowClick={(param) => {
						navigate(`${PAGES_URLS.FoerderDashboard}`, {
							state: {
								id: param.id,
							},
						});
					}}
					initialState={{
						pagination: {
							paginationModel: { pageSize: 10, page: 0 },
						},
						filter: {
							filterModel: {
								items: [get(location, 'state.filter', {})],
							},
						},
					}}
					localeText={deDE.components.MuiDataGrid.defaultProps.localeText}
					slots={{ toolbar: GridToolbar }}
				/>
			</Box>
		</Container>
	);
}

export default MeineAntraege;
